export default "__VITE_ASSET__CGhO3SL$__"